import React from 'react';

import {FrontlineCheckbox} from '../../Shared/FrontlineCheckbox';

export const DefaultItem = ({item, index, isMultipleChoices, isChecked, onSelect, onClick}) => {
    return (
        <div
            key={item.label}
            className="truncate w-full px-1 py-sm-1 rounded-3 cursor-pointer text-main-normal hover:bg-windowsandmenus-hover flex flex-row items-center gap-2"
            style={{borderBottom: index === -1 ? '1px solid var(--panels-normal-color)' : null}}
            data-testid={`select-option-${item.label}`}
            onClick={() => isMultipleChoices ? onClick() : onSelect(item)}
        >
            {isMultipleChoices && (
                <FrontlineCheckbox isChecked={isChecked} onChange={() => {}} size={24} isWithPadding={false} />
            )}
            <div className="truncate">
                {item.label}
            </div>
        </div>
    );
};
